import { __assign } from "tslib";
import { AppServices } from '@singularsystems/neo-core';
var NeoReactTypes = __assign(__assign({}, AppServices.NeoTypes), { Components: {
        Slider: new AppServices.ServiceIdentifier("NeoReact.Slider"),
        Range: new AppServices.ServiceIdentifier("NeoReact.Range"),
        SketchPicker: new AppServices.ServiceIdentifier("NeoReact.SketchPicker"),
        ReactSelect: new AppServices.ServiceIdentifier("NeoReact.ReactSelect"),
        AsyncSelect: new AppServices.ServiceIdentifier("NeoReact.AsyncSelect"),
        IconFactory: new AppServices.ServiceIdentifier("NeoReact.IconFactory")
    }, Routing: __assign(__assign({}, AppServices.NeoTypes.Routing), { NavigationHelper: AppServices.NeoTypes.Routing.NavigationHelper.asType(), GlobalRoutingState: new AppServices.ServiceIdentifier("NeoReact.GlobalRoutingState") }), Services: {
        DisposeHelper: new AppServices.ServiceIdentifier("NeoReact.DisposeHelper")
    } });
export { NeoReactTypes };
